import React, { Fragment } from 'react'

import { Helmet } from 'react-helmet'

import Navbar8 from '../components/navbar8'
import Carousel from '../components/carousel'
import Pricing14 from '../components/pricing14'
import Testimonial17 from '../components/testimonial17'
import CTA26 from '../components/cta26'
import Footer4 from '../components/footer4'
import './home.css'

const Home = (props) => {
  return (
    <div className="home-container">
      <Helmet>
        <title>Sydrisworx</title>
        <meta property="og:title" content="Sydrisworx" />
      </Helmet>
      <Navbar8
        link1={
          <Fragment>
            <span className="home-text10">Home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text11">Services</span>
          </Fragment>
        }
        link3={
          <Fragment>
            <span className="home-text12">Contact Us</span>
          </Fragment>
        }
      ></Navbar8>
      <Carousel
        text7={
          <Fragment>
            <span className="home-text13">
              With a keen focus on collaboration, empowerment, and walking the
              journey with our partners, we provide end-to-end data solutions,
              strategic advisory services, and skills development to drive
              business value in the digital age.
            </span>
          </Fragment>
        }
        button={
          <Fragment>
            <span className="home-text14">Read More...</span>
          </Fragment>
        }
        button2={
          <Fragment>
            <span className="home-text15">Read More...</span>
          </Fragment>
        }
        heading={
          <Fragment>
            <span className="home-text16">Sydrisworx</span>
          </Fragment>
        }
        text611={
          <Fragment>
            <span className="home-text17">
              Cloud solutions tailored to optimise your organisation&apos;s
              needs.
            </span>
          </Fragment>
        }
        text6112={
          <Fragment>
            <span className="home-text18">The future is African</span>
          </Fragment>
        }
        rootClassName="carouselroot-class-name"
      ></Carousel>
      <Pricing14
        plan1={
          <Fragment>
            <span className="home-text19">
              Data Solutions and Digital Transformation
            </span>
          </Fragment>
        }
        plan2={
          <Fragment>
            <span className="home-text20">
              Strategy &amp; Advisory Services
            </span>
          </Fragment>
        }
        plan3={
          <Fragment>
            <span className="home-text21">
              Skills Development &amp; Training
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text22">
              Designing Effective Training Programs
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text23">What We Offer</span>
          </Fragment>
        }
        plan1Action={
          <Fragment>
            <span className="home-text24">Connect With Us</span>
          </Fragment>
        }
        plan1Feature1={
          <Fragment>
            <span className="home-text25">Business Intelligence</span>
          </Fragment>
        }
        plan1Feature2={
          <Fragment>
            <span className="home-text26">Technology Integration</span>
          </Fragment>
        }
        plan1Feature3={
          <Fragment>
            <span className="home-text27">Data Analytics Services</span>
          </Fragment>
        }
        plan2Feature1={
          <Fragment>
            <span className="home-text28">Implementation Roadmaps</span>
          </Fragment>
        }
        plan2Feature2={
          <Fragment>
            <span className="home-text29">Strategic Planning Support</span>
          </Fragment>
        }
        plan3Feature1={
          <Fragment>
            <span className="home-text30">14+ Tailored Programs</span>
          </Fragment>
        }
        plan3Feature2={
          <Fragment>
            <span className="home-text31">Expert Facilitation</span>
          </Fragment>
        }
        plan3Feature3={
          <Fragment>
            <span className="home-text32">
              Continuous Learning Opportunities
            </span>
          </Fragment>
        }
        plan3Feature4={
          <Fragment>
            <span className="home-text33">Workshops and Seminars</span>
          </Fragment>
        }
        rootClassName="pricing14root-class-name"
        plan1Feature22={
          <Fragment>
            <span className="home-text34">Management Consulting</span>
          </Fragment>
        }
        plan1Feature32={
          <Fragment>
            <span className="home-text35">
              Data &amp; Infrastructure Gap Assessment
            </span>
          </Fragment>
        }
        plan3Feature22={
          <Fragment>
            <span className="home-text36">
              Client-Centric Curriculum Development
            </span>
          </Fragment>
        }
        plan1Feature221={
          <Fragment>
            <span className="home-text37">Professional Services</span>
          </Fragment>
        }
        plan1Feature321={
          <Fragment>
            <span className="home-text38">Transformation Go-to Plan</span>
          </Fragment>
        }
        plan1Feature322={
          <Fragment>
            <span className="home-text39">AI Readiness Assessment</span>
          </Fragment>
        }
      ></Pricing14>
      <Testimonial17
        review1={
          <Fragment>
            <span className="home-text40">
              Optimi Workplace is a proud member of the Optimi Group. Accessible
              learning solutions for corporate and public sector training.
            </span>
          </Fragment>
        }
        review2={
          <Fragment>
            <span className="home-text41">
              Leading sustainable tourism development for inclusive economic
              growth in South Africa.
            </span>
          </Fragment>
        }
        review3={
          <Fragment>
            <span className="home-text42">
              ​​​​​​​​​​​​​​​​​​​​Transnet is the largest and most crucial part
              of the freight logistics chain that delivers goods to each and
              every South African.
            </span>
          </Fragment>
        }
        content1={
          <Fragment>
            <span className="home-text43">
              We work with some of the largest service providers locally,
              subject matter experts, and other established organisations to
              ensure our training programs are relevant, of the highest quality,
              provide valuable knowledge and are delivered by seasoned educators
            </span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text44">Our Clients</span>
          </Fragment>
        }
        rootClassName="testimonial17root-class-name"
        author1Position={
          <Fragment>
            <span className="home-text45">Optimi Workplace</span>
          </Fragment>
        }
        author2Position={
          <Fragment>
            <span className="home-text46">Department of Tourism</span>
          </Fragment>
        }
        author3Position={
          <Fragment>
            <span className="home-text47">Transnet</span>
          </Fragment>
        }
      ></Testimonial17>
      <CTA26
        action1={
          <Fragment>
            <span className="home-text48">Get in touch with us today</span>
          </Fragment>
        }
        heading1={
          <Fragment>
            <span className="home-text49">
              Reach out and let us help you, bridge the data &amp; digital gap!
            </span>
          </Fragment>
        }
      ></CTA26>
      <Footer4
        link1={
          <Fragment>
            <span className="home-text50">Home</span>
          </Fragment>
        }
        link2={
          <Fragment>
            <span className="home-text51">Services</span>
          </Fragment>
        }
        link4={
          <Fragment>
            <span className="home-text52">Contact Us</span>
          </Fragment>
        }
      ></Footer4>
    </div>
  )
}

export default Home
